import React from "react";
import S from "../../styles/components";
import Icon from "../Icon";
const downIcon = () => {
  return (
    <svg
      width="13"
      height="8"
      viewBox="0 0 13 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.6143 1.91895L6.61426 6.91895L1.61426 1.91895"
        stroke="#677791"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
const upIcon = () => {
  return (
    <svg
      width="12"
      height="8"
      viewBox="0 0 12 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 6.36352L6 1.36352L11 6.36353"
        stroke="#677791"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
const ListNodeLabel = ({
  title,
  badge,
  icon,
  selected,
  collapsed,
  onToggleCollapse,
  onClick,
}) => {
  const handleMouseHover = (e) => {
    const containerWidth = e.target.clientWidth;
    const titleElement = e.target.querySelector(`.list-item-title`);
    const titleElementWidth = titleElement.clientWidth;

    if (titleElementWidth > containerWidth) {
      const maxTransformTime = 15;
      const minTransformTime = 1;
      const percentage = 1 - containerWidth / titleElementWidth;

      const transformTime =
        percentage * maxTransformTime < 1
          ? minTransformTime
          : percentage * maxTransformTime;

      if (e.type === "mouseenter") {
        titleElement.style.transform = `translateX(calc(-100% + ${
          containerWidth / 2
        }px))`;
        titleElement.style.transition = `transform linear ${transformTime}s`;
      } else if (e.type === "mouseleave") {
        titleElement.style.transform = "";
        titleElement.style.transition = "transform linear 3s";
      }
    }
  };

  return (
    <S.ListItem>
      {onToggleCollapse && (
        <S.ListGroupMarker onClick={onToggleCollapse}>
          {collapsed ? (
            <S.ListGroupMark>{downIcon()}</S.ListGroupMark>
          ) : (
            <S.ListGroupMark>{upIcon()}</S.ListGroupMark>
          )}
        </S.ListGroupMarker>
      )}
      <S.ListItemContent onClick={onClick} selected={selected}>
        <S.ListItemTitle
          onMouseEnter={handleMouseHover}
          onMouseLeave={handleMouseHover}
          selected={selected}
        >
          <div
            className={"list-item-title"}
            style={{ color: selected ? "#339EEC" : "#677791" }}
            title={title}
          >
            {selected && icon}
            {title}
          </div>
        </S.ListItemTitle>
        {badge !== undefined && (
          <S.ListItemBadge style={{ color: selected ? "#339EEC" : "#677791" }}>
            {badge}
          </S.ListItemBadge>
        )}
      </S.ListItemContent>
    </S.ListItem>
  );
};

export default ListNodeLabel;
